/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const customFieldDataLocationSchema = z.enum(['invoice'])

export type CustomFieldDataLocationSchema = z.infer<typeof customFieldDataLocationSchema>
